import axios from "../utils/axios";

export const getPoolList = () => {
    return axios.get(`Pool/GetList`);
};

export const getUnPlannedMaintenanceList = (payload) => {
    return axios.post(`/UnplannedMaintenance/GetPaged?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`, payload.data);
};

export const getUnPlannedMaintenanceListMultiple = (payload) => {
    return axios.post(`/UnplannedMaintenance/GetPagedMultipleChoices?PageSize=${payload.pageSize}&PageNumber=${payload.currentPage}`, payload.data);
};

export const getStatusList = () => {
    return axios.get(`/UnplannedMaintenance/GetStatusList`);
};

export const getActiveCounts = () => {
    return axios.get(`/UnplannedMaintenance/GetActiveCounts`);
};

export const getTechList = () => {
    return axios.get(`/User/GetTechnicianList`);
};

export const getAreaList = () => {
    return axios.get(`/Area/GetList`);
};

export const getCostCenterList = () => {
    return axios.get(`/CostCenter/GetCostCenterList`);
};

export const getEquipmentMainList = (payload) => {
    return axios.get(`/Equipment/GetMainListByAreaID?areaId=${payload}`);
};

export const getEquipmentSubList = (payload) => {
    return axios.get(`/Equipment/GetSubListById?equipmentId=${payload}`);
};

export const getReasonGroup = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};

export const getEffects = () => {
    return axios.get(`/BreakdownEffect/GetList`);
};

export const downloadExcelFile = (filter) => {
    return axios.post(`/UnplannedMaintenance/ExportTasks`, filter, {
        responseType: "blob",
    });
};
